import { useContext,useState } from "react"
import { ItemsContext } from "../contexts/ItemsContext"
import { useRef } from 'react'



const Register=()=>{

    const {registerUser,setLogin,users,setSignup}=useContext(ItemsContext)
    const [username,setUsername]=useState("")
     const [email,setEmail]=useState("")
     const [password,setPassword]=useState("")
     const [passwordConfirm,setPasswordConfirm]=useState("")
     const [errors,setErrors]=useState([[]])
     const myLoginRef = useRef(null)
     const myButtonRef = useRef(null)

    //  useEffect(() => {
    //     // if (myLoginRef.current) {//fully loaded with virtual DOM, because initially not loaded, null(false). //
    //     //     window.scrollTo({
    //     //       top: myLoginRef.current.offsetTop,
    //     //       behavior: 'instant' // the most quick scroll... //
    //     //     });
    //     //   }
    //     // if (myLoginRef.current) { //fully loaded with virtual DOM, because initially not loaded, null(false). //
    //     //   myLoginRef.current.scrollIntoView({ behavior: 'smooth' });
    //     // }
    //   }, [])
      const handleHover = () => {
        if (myButtonRef.current) {
            document.documentElement.scrollIntoView({ behavior: 'smooth' })
        }
      }
     const handleClick=()=>{
        setLogin(false)
        setSignup(false)
    }
    const handleClick2=()=>{
        setSignup(false)
        setLogin(true)
     }
    const handleSubmit=(e)=>{
        e.preventDefault()
        const newErrors=[]
        if(password.length<6){newErrors.push("Password must be at least 6 characters in lenght")}
        if(password !== passwordConfirm){newErrors.push("Passwords do not match")}
        if(username.length<3){newErrors.push("Username must be at least 3 characters in lenght")}
        if(users.length>0){
            if(users.find(u=>u.username===username)){newErrors.push("Username already in use")}
            if(users.find(u=>u.email===email)){newErrors.push("Email already in use")}
        }
        if(newErrors.length>0){
            setErrors(newErrors);
            return
        }
        registerUser(username,email,password)
        setUsername("")
        setEmail("")
        setPassword("")
        setPasswordConfirm("")     
        setLogin(true)
        setSignup(false)
        //setTimeout(()=>alert("The user has been successfully REGISTERED."),100)       
    }

    return(
        <div className="register">
             <button className="back" ref={myButtonRef} onMouseOver={handleHover} onClick={handleClick}>Back</button>
            <h2>Sign up</h2>
            {(errors.length > 0) && 
                <div className="error-container" style={{ display: errors.length > 0 ? 'block' : 'none' }}>
               
                {errors.map((error, index) => (
                <div key={index}>{error}</div>
                ))}    
            </div>
            }
           
            <form onSubmit={handleSubmit}>
                <label>Username: </label>
                <input 
                    type="text" 
                    placeholder="Write a username..." 
                    value={username}
                    onChange={(e)=>setUsername(e.target.value)}
                    name="username"
                    autoComplete="username"
                    required
                />
                <label>Email: </label>
                <input 
                    type="email" 
                    placeholder="Write a email..." 
                    value={email}
                    onChange={(e)=>setEmail(e.target.value)}
                    name="email"
                    autoComplete="email"
                    required
                /> 
                <label>Password: </label>
                <input 
                    type="password" 
                    placeholder="Write a password..." 
                    value={password}
                    onChange={(e)=>setPassword(e.target.value)}
                    name="password"
                    autoComplete="current-password"
                    required
                />
                 <label>Confirm password: </label>
                <input 
                    type="password" 
                    placeholder="confirm a password..." 
                    value={passwordConfirm}
                    onChange={(e)=>setPasswordConfirm(e.target.value)}
                    name="password"
                    autoComplete="current-password"
                    required
                />
                <button>Create account</button>
            </form>
            <br></br>
            <p ref={myLoginRef}>Already have a TaskRanger account? <span className="back2" onClick={handleClick2}> {"  "}Login in</span></p> 
        </div>
    )
}

export default Register